// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getDatabase} from "firebase/database"
import {getStorage} from "firebase/storage"
import {getFirestore,collection,addDoc,getDocs,doc,getDoc,query,where,setDoc,deleteDoc, updateDoc} from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCxEgzd2bmKtX4tDk9MgKXEnBTlxliat4A",
  authDomain: "whatshilos.firebaseapp.com",
  projectId: "whatshilos",
  storageBucket: "whatshilos.firebasestorage.app",
  messagingSenderId: "859787402745",
  appId: "1:859787402745:web:46daf3f13d561d76e37128",
  measurementId: "G-7JFN7D78PD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const storage=getStorage(app)



export const db=getFirestore(app) ///storeGestor.empresas[Auth.dbUser.idDB].idDB

